"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERRIDE_VALIDATION_PER_COUNTRY = exports.OVERRIDE_PAD_PER_COUNTRY = exports.EXEMPTED_COUNTRY_PHONE_CODES = void 0;
var EXEMPTED_COUNTRY_PHONE_CODES = ['US', 'CA', 'UM', 'YT', 'RE', 'AU', 'CX', 'CC', 'AQ', 'NF'];
exports.EXEMPTED_COUNTRY_PHONE_CODES = EXEMPTED_COUNTRY_PHONE_CODES;
var OVERRIDE_PAD_PER_COUNTRY = [{
  country: 'ID',
  placeholder: '####-###-######'
}];
exports.OVERRIDE_PAD_PER_COUNTRY = OVERRIDE_PAD_PER_COUNTRY;
var OVERRIDE_VALIDATION_PER_COUNTRY = [{
  country: 'ID',
  regex: '^(08[1-9][0-9]{6,10}|0[2-3][1-9][0-9]{5,8}|9[0-9][0-9]{6,12}|8[0-9][0-9]{6,12})$'
}];
exports.OVERRIDE_VALIDATION_PER_COUNTRY = OVERRIDE_VALIDATION_PER_COUNTRY;